var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.31 160.69a16 16 0 11-22.62 0 16 16 0 0122.62 0zm-86.62-8a16 16 0 1022.62 0 16 16 0 00-22.62 0zm14.62-33.38a16 16 0 10-22.62 0 16 16 0 0022.62 0zm48-6.62a16 16 0 100 22.62 16 16 0 000-22.62zM236 128A108 108 0 11128 20a12 12 0 0112 12 36 36 0 0036 36 12 12 0 0112 12 36 36 0 0036 36 12 12 0 0112 12zm-24.67 10.65A60.17 60.17 0 01165 91a60.17 60.17 0 01-47.66-46.32 84 84 0 1094 94z"
  })));
}
export default SvgCookie;